import React from 'react';
import { PopoverNextProps } from '.';
// @ts-ignore
import { PopoverNext } from '../../dist/cjs';

// This object should contain a mock value for each required prop of this component
export const requiredProps: PopoverNextProps = {
  open: true,
  onOpenChange: () => {},
  children: (
    <>
      <PopoverNext.Trigger>
        <button>Trigger</button>
      </PopoverNext.Trigger>
      <PopoverNext.Content>Content</PopoverNext.Content>
    </>
  ),
};

const props: PopoverNextProps = { ...requiredProps };

// This array should contain an object only for tests you wish to run on all compliance tests
const sharedTests = [
  {
    props,
  },
];

export const testkitTests = [...sharedTests];

export const ssrTests = [...sharedTests];

export const a11yTests = [...sharedTests];
